window.CampaignRewardsIndexPage = {
    load() {
        if($('.campanha-recompensas-index').length > 0) {
             $('.reward_active-toggle').bootstrapSwitch({
                onColor: 'success',
                size: 'mini',
                onSwitchChange: function(event,state){
                    $(this).attr('checked',state);
                    $.get('/usuario/campanha-recompensas/'+$(this).data('project')+'/toggle-active',{
                        reward : $(this).data('reward')
                    },() => {
                        $(this).parents('.reward-card').first().toggleClass('reward-active reward-inactive')
                        $(this).parents('.reward-card').first().find('.reward-inactive-toggle').toggleClass('hidden')
                    })
                }
                // onColor: 'pink',
            });

            $('.reward-footer_delete').click(function(){
                CampaignRewardsIndexPage.openDeleteRewardModal($(this).attr('data-project'),$(this).attr('data-reward'))
            });

            $('#btnDeleteReward').click(function(){
                CampaignRewardsIndexPage.deleteReward($(this).attr('data-project'),$(this).attr('data-reward'));
            });
            CampaignRewardsIndexPage.sameHeightRewards();
        }
    },
    deleteReward(project,reward){
        if(project && reward){
            $('#btnDeleteReward').button('loading');
            $.get('/usuario/campanha-recompensas/'+project+'/remover',{
                reward : reward
            },() => {
                $('.reward[data-id='+reward+']').parents('.reward-card-wrapper').fadeOut();
                $('#deleteRewardModal').modal('hide');

                $('#btnDeleteReward')
                    .attr({'data-project' :null,'data-reward' : null});

                $('#btnDeleteReward').button('reset');
            });
        }
    },
    openDeleteRewardModal(project,reward){
        $('#btnDeleteReward')
            .attr({'data-project' :project,'data-reward' : reward});
        $('#deleteRewardModal').modal('show');
    },
    sameHeightRewards(){
        let mH = 0;
        for(let reward of document.querySelectorAll('.reward')){
           let rH = reward.offsetHeight;
           mH = rH > mH ? rH : mH;
        }

        $('.reward').css({minHeight: mH+'px'})
    },
};

CampaignRewardsIndexPage.load();